import { createContext, use } from 'react'

import type { OpenOptions, OpenOutcome } from './supportChat'

export interface SupportChat {
  /** `features.support_chat`, with a widget to load. */
  available: boolean
  /**
   * Opens the chat, about `reference` when one is given. `failed` leaves the
   * reason in `error`, so the caller can fall back to `/support`; a
   * `superseded` open, cut short by a sign-out, is nothing to fall back from.
   */
  open: (options?: OpenOptions) => Promise<OpenOutcome>
  /** True while an `open` is in flight; a control that opens is held meanwhile. */
  opening: boolean
  /** Operator messages since the panel was last open. Never persisted. */
  unread: number
  /** Why the last `open` failed, or why its chat was given up; else `null`. */
  error: unknown
  /**
   * Whether the chat's panel is open. It sits outside the app's DOM, so a
   * modal dialog under it has to stop claiming to be the only thing there.
   */
  panelOpen: boolean
}

export const SupportChatContext = createContext<SupportChat | null>(null)

export function useSupportChat(): SupportChat {
  const chat = use(SupportChatContext)
  if (!chat) throw new Error('useSupportChat used outside SupportChatProvider')
  return chat
}
